import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "dialog",
  class: "change-password rounded-lg p-6 max-w-sm w-full shadow-lg"
}
const _hoisted_2 = { class: "flex justify-end space-x-3 mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Current Password ", -1 /* CACHED */)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.dat_old_password) = $event)),
        tabindex: "160",
        class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.dat_old_password]
      ]),
      _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.dat_old_password_error), 513 /* TEXT, NEED_PATCH */), [
        [_vShow, $setup.dat_old_password_error]
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[6] || (_cache[6] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " New Password ", -1 /* CACHED */)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.dat_new_password) = $event)),
        tabindex: "160",
        class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.dat_new_password]
      ]),
      _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.dat_new_password_error), 513 /* TEXT, NEED_PATCH */), [
        [_vShow, $setup.dat_new_password_error]
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[7] || (_cache[7] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Repeat New Password ", -1 /* CACHED */)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.dat_repeat_new_password) = $event)),
        tabindex: "160",
        class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.dat_repeat_new_password]
      ]),
      _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.dat_repeat_new_password_error), 513 /* TEXT, NEED_PATCH */), [
        [_vShow, $setup.dat_repeat_new_password_error]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_basic_button, {
        error: "",
        disabled: $setup.dat_loading,
        size: 'small',
        onClick: _cache[3] || (_cache[3] = $event => ($setup.cancel()))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */,
        __: [8]
      }, 8 /* PROPS */, ["disabled"]),
      _createVNode(_component_basic_button, {
        disabled: $setup.dat_loading,
        size: 'small',
        onClick: _cache[4] || (_cache[4] = $event => ($setup.change_password($setup.dat_old_password, $setup.dat_new_password, $setup.dat_repeat_new_password)))
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("span", null, _cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "fa-solid fa-spinner animate-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Updating...")
          ]), 512 /* NEED_PATCH */), [
            [_vShow, $setup.dat_loading]
          ]),
          _withDirectives(_createElementVNode("span", null, "Change Password", 512 /* NEED_PATCH */), [
            [_vShow, !$setup.dat_loading]
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ])
  ], 512 /* NEED_PATCH */))
}